import React from 'react';

import { Box } from '@mui/material';

import {
  NO_FILE_LABEL,
  PreviewKind,
  TemplateChangeKind,
  TemplateRequestStatus,
} from '../../FormChangeHistory.constants';
import { TemplateChangesetPropTypes } from '../../FormChangeHistory.propTypes';
import { changesetStyles } from '../../FormChangeHistory.styles';
import {
  getChangePreviewPanes,
  getTemplatePreviewPresence,
  hasTemplatePreview,
} from '../../FormChangeHistory.utils';
import useTemplateChanges from '../../hooks/useTemplateChanges';
import PdfTemplateFacts from '../PdfTemplateFacts';
import TemplatePreviewAction from '../TemplatePreviewAction';
import TemplateRequestState from '../TemplateRequestState';

/**
 * The `forms.pdfFile` / `forms.pdfFieldMapping` renderer: the uploaded PDF's facts on both sides,
 * each openable, both side by side, and the field-mapping diff. A row writing both fields shows one
 * block (the mapping is hidden as the file's companion).
 */
const PdfTemplateChangeset = ({ change, detail }) => {
  const { auditId, status, data, retry } = useTemplateChanges({
    change,
    detail,
    kind: TemplateChangeKind.PDF,
  });

  if (status !== TemplateRequestStatus.LOADED) {
    return (
      <Box sx={changesetStyles}>
        <TemplateRequestState emptyLabel={NO_FILE_LABEL} status={status} onRetry={retry} />
      </Box>
    );
  }

  return (
    <>
      <TemplatePreviewAction
        auditId={auditId}
        isHidden={!hasTemplatePreview(data)}
        kind={PreviewKind.CHANGE}
        occurredAtUtc={detail.summary.occurredAtUtc ?? null}
        panes={getChangePreviewPanes(getTemplatePreviewPresence(data))}
        templateKind={TemplateChangeKind.PDF}
      />
      <PdfTemplateFacts auditId={auditId} pdf={data.pdf} />
    </>
  );
};

PdfTemplateChangeset.propTypes = TemplateChangesetPropTypes;

export default PdfTemplateChangeset;
